import { combineReducers } from "redux";
import { apiReducer } from '../../utils/api/reducer';
import { ContestApiResponse } from "../queries/queryTypes";
import { Constants } from './constants';

export const selectedContest = (state = {} as ContestApiResponse, action: any) => {
  switch (action.type) {
    case Constants.SET_CONTEST:
      return action.payload;
    default:
      return state;
  }
};

export const enabledContest = (state = {} as ContestApiResponse, action: any) => {
  switch (action.type) {
    case Constants.SET_ENABLED_CONTEST:
      return action.payload;
    default:
      return state;
  }
};

export const selectedUser = (state = "", action: any) => {
  switch (action.type) {
    case Constants.SET_USER:
      return action.payload || "";
    default:
      return state;
  }
};

export const selectedOpponent = (state = "", action: any) => {
  switch (action.type) {
    case Constants.SET_OPPONENT:
      return action.payload;
    default:
      return state;
  }
};

const initialPageState = {
  user: {
    pageSize: 150,
    currentPage: 1,
  },
  player: {
    pageSize: 150,
    currentPage: 1,
  },
  lineup: {
    pageSize: 150,
    currentPage: 1,
  },
  stack: {
    pageSize: 150,
    currentPage: 1,
  },
}

export const pageInfo = (state = initialPageState, action: any) => {
  switch (action.type) {
    case Constants.SET_PAGE:
      return {
        ...action.payload
      };
    default:
      return state;
  }
};

const initialFilterState = {
  user: {
    sortBy: 'LINEUPS',
    sortOrder: 'DESC'
  },
  player: {
    all: {
      sortBy: 'SIMROI',
      sortOrder: 'DESC'
    },
    user: {
      sortBy: 'OWNERSHIP',
      sortOrder: 'DESC'
    },
    opp: {
      sortBy: 'OWNERSHIP',
      sortOrder: 'DESC'
    },
  },
  lineup: {
    all: {
      sortBy: 'SIMROI',
      sortOrder: 'DESC'
    },
    user: {
      sortBy: 'SIMROI',
      sortOrder: 'DESC'
    },
    opp: {
      sortBy: 'SIMROI',
      sortOrder: 'DESC'
    },
  },
  stack: {
    all: {
      sortBy: 'TEAM',
      sortOrder: 'DESC'
    },
    user: {
      sortBy: 'TEAM',
      sortOrder: 'DESC'
    },
    opp: {
      sortBy: 'TEAM',
      sortOrder: 'DESC'
    },
  },
}

export const filters = (state = initialFilterState, action: any) => {
  switch (action.type) {
    case Constants.SET_USER_SORT:
      return {
        ...state,
        user: { ...action.payload }
      }
    case Constants.SET_PLAYER_SORT:
      return {
        ...state,
        player: { ...action.payload }
      }
    case Constants.SET_LINEUP_SORT:
      return {
        ...state,
        lineup: { ...action.payload }
      }
    case Constants.SET_STACK_SORT:
      return {
        ...state,
        stack: { ...action.payload }
      }
    default:
      return state;
  }
}

const initialPaginationState = {
  user: {
    all: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    },
    user: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    }
  },
  player: {
    all: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    },
    user: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    },
    opponent: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    },
  },
  lineup: {
    all: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    },
    user: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    },
    opponent: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    },
  },
  stack: {
    all: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    },
    user: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    },
    opponent: {
      currentPage: 0,
      nextPageLink: "",
      pageSize: 0,
      previousPageLink: null,
      totalCount: 0,
      totalPages: 0,
    },
  },
};

export const pagination = (state = initialPaginationState, action: any) => {
  switch (action.type) {
  case Constants.SET_USER_ROI_PAGINATION:
      return {
        ...state,
        user: {
          ...state.user,
            all: action.payload
        }
      }
  case Constants.SET_USER_NAME_ROI_PAGINATION:
      return {
        ...state,
        user: {
          ...state.user,
            user: action.payload
        }
      }
  case Constants.SET_PLAYER_ALL_ROI_PAGINATION:
      return {
        ...state,
        player: {
          ...state.player,
            all: action.payload
        }
      }
  case Constants.SET_PLAYER_USER_ROI_PAGINATION:
      return {
        ...state,
        player: {
          ...state.player,
            user: action.payload
        }
      }
  case Constants.SET_PLAYER_OPPONENT_ROI_PAGINATION:
      return {
        ...state,
        player: {
          ...state.player,
            opponent: action.payload
        }
      }
  case Constants.SET_LINEUP_ALL_ROI_PAGINATION:
      return {
        ...state,
        lineup: {
          ...state.lineup,
            all: action.payload
        }
      }
  case Constants.SET_LINEUP_USER_ROI_PAGINATION:
      return {
        ...state,
        lineup: {
          ...state.lineup,
            user: action.payload
        }
      }
  case Constants.SET_LINEUP_OPPONENT_ROI_PAGINATION:
      return {
        ...state,
        lineup: {
          ...state.lineup,
            opponent: action.payload
        }
      }
  case Constants.SET_STACK_ALL_ROI_PAGINATION:
      return {
        ...state,
        stack: {
          ...state.lineup,
            all: action.payload
        }
      }
  case Constants.SET_STACK_USER_ROI_PAGINATION:
      return {
        ...state,
        stack: {
          ...state.lineup,
            user: action.payload
        }
      }
  case Constants.SET_STACK_OPP_ROI_PAGINATION:
      return {
        ...state,
        stack: {
          ...state.lineup,
            opponent: action.payload
        }
      }
    default:
      return state;
  }
}

export const selectedDate = (state = null, action: any) => {
  switch (action.type) {
    case Constants.SET_DATE:
      return action.payload;
    default:
      return state;
  }
}


export const postContestReducer = combineReducers({
  selectedContest,
  enabledContest,
  selectedUser,
  selectedOpponent,
  filters,
  pageInfo,
  userRoi: apiReducer(Constants.SET_USER_ROI),
  userNameRoi: apiReducer(Constants.SET_USER_NAME_ROI),
  playerAllRoi: apiReducer(Constants.SET_PLAYER_ALL_ROI),
  playerUserRoi: apiReducer(Constants.SET_PLAYER_USER_ROI),
  playerOpponentRoi: apiReducer(Constants.SET_PLAYER_OPPONENT_ROI),
  lineupAllRoi: apiReducer(Constants.SET_LINEUP_ALL_ROI),
  lineupUserRoi: apiReducer(Constants.SET_LINEUP_USER_ROI),
  lineupOpponentRoi: apiReducer(Constants.SET_LINEUP_OPPONENT_ROI),
  stackRoiAll: apiReducer(Constants.SET_STACK_ALL_ROI),
  stackRoiUser: apiReducer(Constants.SET_STACK_USER_ROI),
  stackRoiOpp: apiReducer(Constants.SET_STACK_OPP_ROI),
  pagination,
  selectedDate,
  slates: apiReducer(Constants.SET_SLATES),
});